import React from 'react'
import PropTypes from 'prop-types'
import { Field, getIn } from 'formik'
import classNames from 'classnames'

import { FormGroup } from '@peracto/peracto-ui'

const Input = ({
    name,
    label = '',
    help,
    className,
    showWhen,
    type = 'text',
    prefix,
    suffix,
    charactercount,
    required = null,
    defaultValue,
    testId,
    tooltip,
    ...props
}) => {
    return (
        <Field name={name}>
            {({ field, form }) => {
                let error = getIn(form.errors, name)

                if (error) {
                    const errorFieldName = label ? label : 'This'
                    error = error.replace(field.name, errorFieldName)
                }

                if (showWhen) {
                    const showField = form.values.hasOwnProperty(showWhen)
                        ? form.values[showWhen]
                        : false

                    if (!showField) {
                        return null
                    }
                }

                props.className = classNames('form-control', className)

                if (help) {
                    props['aria-describedby'] = `${name}Help`
                }

                if (field.value === null) {
                    if (defaultValue) {
                        field.value = form.setFieldValue(field.name, defaultValue)
                    } else {
                        field.value = ''
                    }
                }

                return (
                    <FormGroup {...{ name, label, tooltip, help, required }} error={error}>
                        <div className="input-group">
                            {prefix && (
                                <div className="input-group-prepend">
                                    <div
                                        className="input-group-text"
                                        data-testid={`${name}-prefix`}
                                    >
                                        {prefix}
                                    </div>
                                </div>
                            )}
                            <input
                                type={type}
                                {...field}
                                {...props}
                                charactercount={charactercount}
                                disabled={form.isSubmitting || props.disabled}
                                data-testid={testId}
                            />
                            {suffix && (
                                <div className="input-group-append">
                                    <div
                                        className="input-group-text"
                                        data-testid={`${name}-suffix`}
                                    >
                                        {suffix}
                                    </div>
                                </div>
                            )}
                        </div>
                    </FormGroup>
                )
            }}
        </Field>
    )
}

Input.displayName = 'Input'

Input.propTypes = {
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    help: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    placeholder: PropTypes.string,
    className: PropTypes.string,
    show: PropTypes.string,
    prefix: PropTypes.string,
}

export default Input
